module.exports = "# PDF Compressor - Easily Compress PDF Online\r\n\r\nAdvanced PDF compressor for reducing file size without quality loss\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/PdfCompressor/pdf-compressor-header.md
// module id = 1186
// module chunks = 0